import React from "react";
import {HomeComponent} from "../../components/LP";
import {HeaderContainer} from "../Header";

export const LP: React.FC = () => {
    return (
        <>
            <HeaderContainer setOpen={() => {}} />
            <HomeComponent />
        </>
    );
};
